export default __webpack_public_path__ + "navigation-examples-custom-navigation-camera-960-2ee33afe457ace1d60bf1075a018b6a7.png";